import type { QuestionBrowseTaxonomy } from '@course-authoring/shared-types';

/** Where a child label sits: its framework and parent, for chips and the label-link jump. */
export interface QuestionBankLabelEntry {
  taxonomyId: number;
  taxonomyName: string;
  parentLabel: string;
  childLabel: string;
}

/** Every live child label in the facets' taxonomies, by id. */
export const indexTaxonomyLabels = (taxonomies: readonly QuestionBrowseTaxonomy[]): ReadonlyMap<number, QuestionBankLabelEntry> => {
  const byId = new Map<number, QuestionBankLabelEntry>();
  for (const taxonomy of taxonomies) {
    for (const parent of taxonomy.parents) {
      for (const child of parent.children) {
        byId.set(child.labelId, { taxonomyId: taxonomy.taxonomyId, taxonomyName: taxonomy.name, parentLabel: parent.label, childLabel: child.label });
      }
    }
  }
  return byId;
};

/** Label chips run framework by framework in this order (the prototype's TAXKEYS), each in the order its labels were checked. */
const CHIP_ORDER = ['Culture', 'Risk', 'Leadership'];

/** The checked label ids in chip order: Culture, Risk, Leadership, then frameworks the order does not name, then labels the facets do not know. */
export const orderLabelIdsForChips = (labelIds: readonly number[], labels: ReadonlyMap<number, QuestionBankLabelEntry>): number[] => {
  const rank = (labelId: number): number => {
    const name = labels.get(labelId)?.taxonomyName;
    if (name === undefined) return CHIP_ORDER.length + 1;
    const index = CHIP_ORDER.indexOf(name);
    return index === -1 ? CHIP_ORDER.length : index;
  };
  return [...labelIds].sort((left, right) => rank(left) - rank(right));
};
